// Klaviyo's "Added to Cart" event, which triggers the Abandoned Cart flow. Klaviyo's app doesn't send it on
// its own, so the old theme did it in code; this puts it back. It catches every add (product form, quick add,
// Rebuy's drawer), with the same event data as before: cart totals and items, plus the product just added.
(() => {
  const ADD = /\/cart\/add(\.js)?(\?|$)/;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const nativeFetch = window.fetch;

  const track = async (added) => {
    try {
      const cart = await (await nativeFetch(`${root}cart.js`)).json();
      const line = (added && added.items ? added.items[0] : added) || {};
      const event = {
        total_price: cart.total_price / 100,
        $value: cart.total_price / 100,
        total_discount: cart.total_discount,
        original_total_price: cart.original_total_price / 100,
        items: cart.items,
      };
      if (line.product_id) {
        Object.assign(event, {
          Name: line.product_title,
          ProductID: line.product_id,
          ImageURL: line.image,
          URL: `${window.location.origin}${line.url}`,
          Brand: line.vendor,
          Price: line.final_price / 100,
          CompareAtPrice: line.original_price / 100,
        });
      }
      (window._learnq = window._learnq || []).push(['track', 'Added to Cart', event]);
    } catch (error) {
      // Tracking must never get in the way of adding to cart
    }
  };

  window.fetch = function (input, init) {
    const response = nativeFetch.apply(this, arguments);
    const url = typeof input === 'string' ? input : input && input.url;
    if (url && ADD.test(url)) {
      response.then((res) => res.ok && res.clone().json().then(track, () => track())).catch(() => {});
    }
    return response;
  };

  const open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (ADD.test(String(url))) {
      this.addEventListener('load', () => {
        if (this.status >= 400) return;
        let body;
        try {
          body = JSON.parse(this.responseText);
        } catch (error) {}
        track(body);
      });
    }
    return open.apply(this, arguments);
  };
})();
